import React, { useState } from 'react';
import Head from '../../layout/head/Head';
import Content from '../../layout/content/Content';
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PreviewCard
} from '../../components/Component';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Row, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import SelectAgent from '../../components/SelectAgent';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

export default function AddPFAgent() {
    const navigate = useNavigate();
    const axios = useAxiosPrivate();
    
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!selectedAgent) {
            toast.error('Please select an agent');
            return;
        }

        try {
            setIsLoading(true);
            
            // Send request to Property Finder API endpoint
            const response = await axios.post(`/property-finder/agent/${selectedAgent.value}`);
            
            if (response.status === 200 || response.status === 201) {
                toast.success('Agent successfully added to Property Finder');
                // Reset form
                setSelectedAgent(null);
            }
            
        } catch (error) {
            console.error('Error adding agent to Property Finder:', error);
            
            // Handle different error scenarios
            if (error.response?.status === 400) {
                toast.error(error.response?.data?.message || 'Invalid request. Please check agent details.');
            } else if (error.response?.status === 409) {
                toast.error('Agent already exists in Property Finder');
            } else if (error.response?.status === 404) {
                toast.error('Agent not found');
            } else {
                toast.error('Failed to add agent to Property Finder. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Head title="Add Property Finder Agent"></Head>
            <Content>
                <BlockHead size="sm">
                    <BlockBetween className="g-3">
                        <BlockHeadContent>
                            <Link>
                                <Button
                                    color="light"
                                    outline
                                    className="bg-white d-none d-sm-inline-flex"
                                    onClick={(e) => navigate(-1)}
                                >
                                    <Icon name="arrow-left"></Icon>
                                    <span>Back</span>
                                </Button>
                                <Button
                                    color="light"
                                    outline
                                    className="btn-icon bg-white d-inline-flex d-sm-none"
                                    onClick={(e) => navigate(-1)}
                                >
                                    <Icon name="arrow-left"></Icon>
                                </Button>
                            </Link>
                            <BlockTitle page className="mt-4">
                                Create Property Finder Account for an Agent
                            </BlockTitle>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <Block>
                    <PreviewCard>
                        <form onSubmit={handleSubmit}>
                            <Row className="gy-4">
                                <Col sm="4">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Select Agent <span className="text-danger">*</span>
                                        </label>
                                        <SelectAgent
                                            selectedAgent={selectedAgent}
                                            onSelectAgent={setSelectedAgent}
                                            placeholder="Choose agent"
                                            allowInactiveAgents={false}
                                            isClearable
                                            notStyled
                                        />
                                        {selectedAgent && (
                                            <div className="form-note mt-2">
                                                Selected: <strong>{selectedAgent.label}</strong>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                                <Col sm="12">
                                    <div className="form-group">
                                        <Button 
                                            type="submit" 
                                            color="primary" 
                                            size="lg"
                                            disabled={isLoading || !selectedAgent}
                                        >
                                            {isLoading && <Spinner size="sm" className="me-2" />}
                                            {isLoading ? 'Adding Agent...' : 'Add Agent to Property Finder'}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </PreviewCard>
                </Block>
            </Content>
        </React.Fragment>
    );
} 